import { Tooltip } from '@mui/material';
import type { ReactElement } from 'react';

/**
 * Wraps `children` in a `Tooltip` only when there is something to say — MUI draws
 * nothing for an empty title but still mounts the listeners.
 */
export const ConditionalTooltip = ({
  title,
  children,
}: {
  title?: string;
  children: ReactElement;
}) =>
  title ? (
    <Tooltip title={title} arrow>
      {children}
    </Tooltip>
  ) : (
    children
  );
